export default "__VITE_ASSET__nokaQ5JD__"